export const Cost_Q4_Check_Details = [
  {
    CheckId: "redshift_reserved_node_purchase_status_check",
    Description: "Redshift Reserved Node Payment Pending",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "underutilized_dynamodb_table_reader",
    Description:
      "Identify any Amazon DynamoDB tables with underutilized read capacity, by downsizing the capacity  can lower the cost of the monthly AWS bill",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unassociated_internet_gateway",
    Description: "Check for unused VPC Internet Gateways (IGWs).",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elasticsearch_cluster_idle_check",
    Description: "Idle Elasticsearch Clusters",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ebs_volume_deleted_on_instance_termination",
    Description:
      "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unused_amazon_machine_images",
    Description: "Unused Amazon Machine Images (AMIs) must be removed",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unassociated_egress_only_internet_gateway",
    Description: "Unused Egress Only Internet Gateways",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "underutilized_dynamodb_table_writes",
    Description:
      "Identify any Amazon DynamoDB tables with underutilized write capacity, by downsizing the capacity can lower the cost of the monthly AWS bill",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unassociated_launch_configuration",
    Description: "Check for unassociated launch configurations",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unassociated_ebs_volume",
    Description: "Check for unused EBS volumes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "redshift_reserved_node_lease_expiration_check",
    Description: "Redshift Reserved Node Lease Expiration",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unused_virtual_private_gateways",
    Description: "Virtual Private Gateways (VPG) must be associated",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_idle_instances_check",
    Description: "RDS Idle DB Instances",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unassociated_ec2_elastic_ip",
    Description: "Check for unassociated Elastic IP addresses",
    ErrorMessages:
      "[{'AccountNumber': '181570489212', 'Message': \"An error occurred (InvalidAllocationID.NotFound) when calling the DescribeAddresses operation: The allocation ID 'eipalloc-0ae7b9a07f7f8b71e' does not exist\", 'RegionCode': 'us-east-1', 'ResourceName': 'eipalloc-0ae7b9a07f7f8b71e'}]",
    Status: "ERROR",
  },
  {
    CheckId: "unused_aws_workspace",
    Description: "Unused AWS WorkSpaces",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "sqs_old_message_check",
    Description:
      "SQS messages should not be older than 80 percent of message retention",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "unassociated_network_interface",
    Description: "Check for unassociated Network Interfaces",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "unused_kms_keys",
    Description: "Check for unused KMS keys",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Cost_Q4_redshift_reserved_node_purchase_status_check = [];
export const Cost_Q4_underutilized_dynamodb_table_reader = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "underutilized_dynamodb_table_reader",
      CreatedAt: "2023-04-25 12:24:10",
      FindingId: "cd2f24fb-f4e8-4c5a-9162-3b6361133753",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify any Amazon DynamoDB tables with underutilized read capacity, by downsizing the capacity  can lower the cost of the monthly AWS bill",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "d0d951e9-d147-4521-913e-40d536a29a69",
      ResourceType: "DynamoDbTable",
      Severity: "Medium",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Cost_Q4_unassociated_internet_gateway = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "4b1c2c26-68b4-49ae-9eb0-8f69470efefe",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-039cbf0db07cc4c6f",
      ResourceType: "InternetGateway",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "10f035b0-0801-4713-8071-3d7f990e3d78",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-0082c00bafcc56797",
      ResourceType: "InternetGateway",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "a57dddfd-4455-4109-842a-5e8631ae327b",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-0985d6f4e65f730ed",
      ResourceType: "InternetGateway",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_internet_gateway",
      CreatedAt: "2023-04-25 12:25:15",
      FindingId: "ace08bdf-71c9-4995-9997-289309e69611",
      Metadata: {
        TaskRefId: "21645979-a604-4c3a-98d8-6c0bda135644",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "It is a best practice to identify and remove any unused VPC Internet Gateways (IGWs) to avoid service limit issues and save cost. This check identifies any unused IGWs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "igw-0f4489b8c0fa15ad2",
      ResourceType: "InternetGateway",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Cost_Q4_elasticsearch_cluster_idle_check = [];
export const Cost_Q4_ebs_volume_deleted_on_instance_termination = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_deleted_on_instance_termination",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "04237c1f-49d9-45d7-a6b5-52e9231e2bde",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ec2:us-east-1:181570489212:volume/vol-04519c70f234c739a",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_deleted_on_instance_termination",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "147baeb9-0475-4cef-83bf-601887c33f9f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ec2:us-east-1:181570489212:volume/vol-06ffbd8c4acb516a1",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_deleted_on_instance_termination",
      CreatedAt: "2023-04-25 12:24:02",
      FindingId: "56ef0dcb-ff0d-49d9-a81f-8bf03a550228",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ec2:us-east-1:181570489212:volume/vol-02d23369d29e03152",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_deleted_on_instance_termination",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "802f9da9-5e71-4854-843a-1809178bfd3e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ec2:us-east-1:181570489212:volume/vol-0ea6b0db4290bf8cb",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_deleted_on_instance_termination",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "d6c6a2cf-2b86-437c-8d42-fce4ba2fd9a0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ec2:us-east-1:181570489212:volume/vol-03d385d8a15e6912b",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_volume_deleted_on_instance_termination",
      CreatedAt: "2023-04-25 12:24:02",
      FindingId: "e04bc596-5c71-4fb8-aa3e-886f0ca5318e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Ensure deletion on termination is enabled to avoid keeping non required volumes when EC2 instance is removed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:ec2:us-east-1:181570489212:volume/vol-006628696d6276613",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Cost_Q4_unused_amazon_machine_images = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unused_amazon_machine_images",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "115fa5c4-549b-47cc-8b5b-39bcf7f0cde2",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Unused Amazon Machine Images (AMIs) result in wasted cloud spend. This check verifies if there are any unused AMIs in your AWS Accounts.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-0a8d4563854aec173",
      ResourceType: "Image",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_amazon_machine_images",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "ba04e266-0b2b-474e-987f-ef9024142862",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Unused Amazon Machine Images (AMIs) result in wasted cloud spend. This check verifies if there are any unused AMIs in your AWS Accounts.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-092c18574fce16603",
      ResourceType: "Image",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Cost_Q4_unassociated_egress_only_internet_gateway = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_egress_only_internet_gateway",
      CreatedAt: "2023-04-25 12:25:12",
      FindingId: "c09a9923-b610-41c6-aa44-9d7bead5a56f",
      Metadata: {
        TaskRefId: "986eef83-9ae8-47d6-967e-086a2065eec1",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify any unused  VPC Egress-Only Internet Gateways (EIGWs)",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eigw-0ded9ae6226e25456",
      ResourceType: "EgressOnlyInternetGateway",
      Severity: "Low",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Cost_Q4_underutilized_dynamodb_table_writes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "underutilized_dynamodb_table_writes",
      CreatedAt: "2023-04-25 12:24:10",
      FindingId: "21ef35ca-d2b7-40e1-b8ae-e4f86c7032ac",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify any Amazon DynamoDB tables with underutilized write capacity, by downsizing the capacity can lower the cost of the monthly AWS bill",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "d0d951e9-d147-4521-913e-40d536a29a69",
      ResourceType: "DynamoDbTable",
      Severity: "Medium",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Cost_Q4_unassociated_launch_configuration = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_launch_configuration",
      CreatedAt: "2023-04-25 12:24:46",
      FindingId: "f3d95f0b-dc23-4f00-8279-7f4293079559",
      Metadata: {
        TaskRefId: "e41dad68-9cef-4c78-9657-a148a1237d62",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "It is a best practice to remove Launch Configuration templates that are not used anymore by AWS Auto Scaling Groups.  This check identifies unassociated launch configurations.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "HumanTech-Production-UnusedResourcesNonCompliant-109RHAL4LPGV7-UnassociatedLaunchConfig-5lYhZBuFmXDP",
      ResourceType: "LaunchConfiguration",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Cost_Q4_unassociated_ebs_volume = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "8c2af975-608c-4795-95c7-a4bb9d1d2eca",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-00390a16574adf858",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "33560d2c-bb54-4cf1-a6c1-09ef361edd40",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-0ea6b0db4290bf8cb",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "df1115ed-329f-4fbc-905e-57e6e48a9245",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-0faf25aeab3cb0efa",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ebs_volume",
      CreatedAt: "2023-04-25 12:24:05",
      FindingId: "e51855c3-ab6b-4e08-bc53-773656e78d87",
      Metadata: {
        TaskRefId: "1f2e5368-9e1b-4d6d-92f2-f11d6301f339",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify unused (unattached) Amazon Elastic Block Store (EBS) volumes available within your AWS cloud account in order to lower the cost of your AWS bill and reduce the risk of confidential and sensitive data leaks.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vol-06ffbd8c4acb516a1",
      ResourceType: "Volume",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};
export const Cost_Q4_redshift_reserved_node_lease_expiration_check = [];
export const Cost_Q4_unused_virtual_private_gateways = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unused_virtual_private_gateways",
      CreatedAt: "2023-04-25 12:24:55",
      FindingId: "6d34fde7-087f-45ad-bfc9-7d0fb502c072",
      Metadata: {
        TaskRefId: "cd1fb596-e0cd-4a10-978c-a4f2c5b35c14",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "It is a best practice to identify and remove any unused VPN Gateways (VPGs) to avoid service limit issues and save cost. This check identifies any unused VPGs.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "vgw-0eb142db128afd4a1",
      ResourceType: "VpnGateway",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Cost_Q4_rds_idle_instances_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_idle_instances_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "fa9b28cb-938b-4f8b-bcab-e6d4d4160810",
      Metadata: {
        TaskRefId: "1c1e0017-c0a7-4091-b5fa-c22d0581d5c1",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify any Amazon RDS database instances that appear to be idle",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_idle_instances_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "3614c143-456a-4506-8900-73d1e866a01d",
      Metadata: {
        TaskRefId: "1c1e0017-c0a7-4091-b5fa-c22d0581d5c1",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Identify any Amazon RDS database instances that appear to be idle",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Cost_Q4_unassociated_ec2_elastic_ip = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ec2_elastic_ip",
      CreatedAt: "2023-04-25 12:24:45",
      FindingId: "c1ebbd2c-7fba-4efc-80eb-19953b6150ab",
      Metadata: {
        TaskRefId: "6a430b20-509f-4324-80e9-ce03b284ca79",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check for any unattached Elastic IP (EIP) addresses in your AWS account and release (remove) them in order to lower the cost of your monthly AWS bill",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eipalloc-0ae7b9a07f7f8b71e",
      ResourceType: "ElasticIp",
      Severity: "Low",
      Status: "Error",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_ec2_elastic_ip",
      CreatedAt: "2023-04-25 12:24:45",
      FindingId: "a866806f-f67e-4eaf-b7bd-4c9095cf2c50",
      Metadata: {
        TaskRefId: "6a430b20-509f-4324-80e9-ce03b284ca79",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check for any unattached Elastic IP (EIP) addresses in your AWS account and release (remove) them in order to lower the cost of your monthly AWS bill",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eipalloc-0387c491883147520",
      ResourceType: "ElasticIp",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Cost_Q4_unused_aws_workspace = [];
export const Cost_Q4_sqs_old_message_check = [];
export const Cost_Q4_unassociated_network_interface = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "d50787fa-54ca-4fdb-b843-b963158163be",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-0d88e9ea9dacaa5f6",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "12bf32b0-b982-4bfa-9880-cc91118e25dc",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-006fc56ce398feeef",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "1e01b709-3129-4c03-9fa1-44e81866d2f8",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-07c46d78936f2fdcd",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "6416b67f-6c81-49ea-b3de-134f8f6c8031",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-0fe2432a3cff11789",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "88f3041c-a311-4544-89ca-199b8f8b05fc",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-077cb96eb994b4e1a",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unassociated_network_interface",
      CreatedAt: "2023-04-25 12:25:07",
      FindingId: "ea9b85d7-2f86-4ccd-9912-7710b4e75e65",
      Metadata: {
        TaskRefId: "b102038e-8dc5-47c4-956f-8dc9b9a9b79d",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Check Unassociated Network Interfaces available in a given region",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "eni-06aa28bda6f6a2f5a",
      ResourceType: "NetworkInterface",
      Severity: "Low",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};
export const Cost_Q4_unused_kms_keys = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "unused_kms_keys",
      CreatedAt: "2023-04-25 12:25:08",
      FindingId: "6c47080a-ae89-43ec-b050-633ccf80fd47",
      Metadata: {
        TaskRefId: "cd57bf21-9bf6-464a-9660-8029e4f54b92",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore. This check identifies unused KMS keys in your account so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "fbbb8caa-260c-43f1-b460-94eef2dd8a28",
      ResourceType: "KMSKey",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "unused_kms_keys",
      CreatedAt: "2023-04-25 12:25:08",
      FindingId: "a09dd78f-82ed-42da-a27b-c9ad08c0de60",
      Metadata: {
        TaskRefId: "cd57bf21-9bf6-464a-9660-8029e4f54b92",
      },
      PillarId: "costOptimization",
      QuestionId: "decomissioning-resources",
      Recommendation:
        "Deleting an AWS KMS key is destructive and potentially dangerous. It deletes the key material and all metadata associated with the KMS key and is irreversible. After a KMS key is deleted, you can no longer decrypt the data that was encrypted under that KMS key, which means that data becomes unrecoverable. You should delete a KMS key only when you are sure that you don't need to use it anymore. This check identifies unused KMS keys in your account so you can safely delete them.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "66d0e6fe-1ae2-4919-85b8-6966f7e2c1c7",
      ResourceType: "KMSKey",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};

export const Cost_Q5_Check_Details = [
  {
    CheckId: "config_enforce_hard_limit_on_license_consumption",
    Description:
      "Do LM configurations enforce a hard limit on license consumption",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Cost_Q6_Check_Details = [
  {
    CheckId: "dynamodb_tables_have_ttl_enabled",
    Description: "Enable TTL for DynamoDB tables",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "workspaces_running_mode_check",
    Description: "WorkSpace running mode set to AutoStop",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "disabled_autoscaling_dynamodb_tables",
    Description: "Disabled autoscaling DynamoDB tables",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Cost_Q9_dynamodb_tables_have_ttl_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "dynamodb_tables_have_ttl_enabled",
      CreatedAt: "2023-04-25 12:24:11",
      FindingId: "758890e6-14f6-4233-81a4-7454cda81bab",
      Metadata: {
        TaskRefId: "469a4eaf-9fd0-45e9-b301-d8d05b28bcce",
      },
      PillarId: "costOptimization",
      QuestionId: "manage-demand-resources",
      Recommendation:
        "Amazon DynamoDB Time to Live (TTL) allows you to define a per-item timestamp to determine when an item is no longer needed. Shortly after the date and time of the specified timestamp, DynamoDB deletes the item from your table without consuming any write throughput. TTL is provided at no extra cost as a means to reduce stored data volumes by retaining only the items that remain current for your workload’s needs. This check verifies if TTL is enabled for DynamoDB tables.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:dynamodb:us-east-1:181570489212:table/test-table-ba377cb0-e354-11ed-8296-0e94021f48fb",
      ResourceType: "DynamoDbTable",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Cost_Q9_workspaces_running_mode_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Cost_Q9_disabled_autoscaling_dynamodb_tables = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "disabled_autoscaling_dynamodb_tables",
      CreatedAt: "2023-04-25 12:24:09",
      FindingId: "446499c9-1618-4343-b4a6-634720a6f4b1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "costOptimization",
      QuestionId: "manage-demand-resources",
      Recommendation:
        "Check whether auto-scaling is enabled for AWS DynamoDB tables in your cloud environment.\nAuto-scaling dynamically adjusts the throughput (read and write) capacity of your provisioned DB tables to meet traffic demands.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:dynamodb:us-east-1:181570489212:table/test-table-ba377cb0-e354-11ed-8296-0e94021f48fb",
      ResourceType: "DynamoDbTable",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const costCheckFindings = {
  [`decomissioning-resources_redshift_reserved_node_purchase_status_check`]:
    Cost_Q4_redshift_reserved_node_purchase_status_check,
  [`decomissioning-resources_underutilized_dynamodb_table_reader`]:
    Cost_Q4_underutilized_dynamodb_table_reader,
  [`decomissioning-resources_unassociated_internet_gateway`]:
    Cost_Q4_unassociated_internet_gateway,
  [`decomissioning-resources_elasticsearch_cluster_idle_check`]:
    Cost_Q4_elasticsearch_cluster_idle_check,
  [`decomissioning-resources_ebs_volume_deleted_on_instance_termination`]:
    Cost_Q4_ebs_volume_deleted_on_instance_termination,
  [`decomissioning-resources_unused_amazon_machine_images`]:
    Cost_Q4_unused_amazon_machine_images,
  [`decomissioning-resources_unassociated_egress_only_internet_gateway`]:
    Cost_Q4_unassociated_egress_only_internet_gateway,
  [`decomissioning-resources_underutilized_dynamodb_table_writes`]:
    Cost_Q4_underutilized_dynamodb_table_writes,
  [`decomissioning-resources_unassociated_launch_configuration`]:
    Cost_Q4_unassociated_launch_configuration,
  [`decomissioning-resources_unassociated_ebs_volume`]:
    Cost_Q4_unassociated_ebs_volume,
  [`decomissioning-resources_redshift_reserved_node_lease_expiration_check`]:
    Cost_Q4_redshift_reserved_node_lease_expiration_check,
  [`decomissioning-resources_unused_virtual_private_gateways`]:
    Cost_Q4_unused_virtual_private_gateways,
  [`decomissioning-resources_rds_idle_instances_check`]:
    Cost_Q4_rds_idle_instances_check,
  [`decomissioning-resources_unassociated_ec2_elastic_ip`]:
    Cost_Q4_unassociated_ec2_elastic_ip,
  [`decomissioning-resources_unused_aws_workspace`]:
    Cost_Q4_unused_aws_workspace,
  [`decomissioning-resources_sqs_old_message_check`]:
    Cost_Q4_sqs_old_message_check,
  [`decomissioning-resources_unassociated_network_interface`]:
    Cost_Q4_unassociated_network_interface,
  [`decomissioning-resources_unused_kms_keys`]: Cost_Q4_unused_kms_keys,

  [`manage-demand-resources_dynamodb_tables_have_ttl_enabled`]:
    Cost_Q9_dynamodb_tables_have_ttl_enabled,
  [`manage-demand-resources_workspaces_running_mode_check`]:
    Cost_Q9_workspaces_running_mode_check,
  [`manage-demand-resources_disabled_autoscaling_dynamodb_tables`]:
    Cost_Q9_disabled_autoscaling_dynamodb_tables,
};
